import { render } from "./Index.vue?vue&type=template&id=5d953208&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5d953208&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d953208"

export default script